<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click="modalClicked">
      <div class="modalOverlay"></div>
      <div :class="{modalContent: true}">
        <h4>Select Category</h4>
        <div class="loadingCategory" v-if="loading"></div>
        <div class="categoryCnt">
          <div class="categoryItem catItemLeft">
            <div class="loadingCategory loading2" v-if="loading1"></div>
            <li v-for="(cat, i) in categories" :key="i" class="canMore"
              v-on:click="selected = cat; selected2 = null; selected3 = null;"
              :class="{selected: selected && selected.id === cat.id}">
              <div class="action">
                <div class="actionItem edit" v-on:click.stop="editCategory(cat)"></div>
                <div class="actionItem delete"
                  v-on:click.stop="deleteCategory(cat, null, i)"></div>
              </div>
              <div class="checkbox" :class="{checked: cat.selected}"
                v-on:click="toggleSelect(cat)"></div>
              <div class="catName">{{cat.name[lang]}}</div>
            </li>
            <button class="addCategory" v-on:click="addCategory">
              <img src="../assets/plus-circle.png">
              Add new category
            </button>
          </div>
          <div class="categoryItem catItemMid" v-if="selected">
            <div class="loadingCategory loading2" v-if="loading2"></div>
            <div class="liCnt" v-if="selected.subcategories">
              <li v-for="(cat, i) in selected.subcategories" :key="i" class="canMore"
                v-on:click="selected2 = cat; selected3 = null;"
                :class="{selected: selected2 && selected2.id === cat.id}">
                <div class="action">
                  <div class="actionItem edit" v-on:click.stop="editCategory(cat)"></div>
                  <div class="actionItem delete"
                    v-on:click.stop="deleteCategory(cat, selected, i)"></div>
                </div>
                <div class="checkbox" :class="{checked: cat.selected}"
                  v-on:click="toggleSelect(cat, selected)"></div>
                <div class="catName">{{cat.name[lang]}}</div>
              </li>
            </div>
            <button class="addCategory" v-on:click="addCategory2">
              <img src="../assets/plus-circle.png">
              Add new category
            </button>
          </div>
          <div class="categoryItem" v-if="selected2">
            <div class="loadingCategory loading2" v-if="loading3"></div>
            <div class="liCnt" v-if="selected2.subcategories">
              <li v-for="(cat, i) in selected2.subcategories" :key="i"
                v-on:click="selected3 = cat"
                :class="{selected: selected3 && selected3.id === cat.id}">
                <div class="checkbox" :class="{checked: cat.selected}"
                  v-on:click="toggleSelect(cat, selected2, selected)"></div>
                <div class="action">
                  <div class="actionItem edit" v-on:click.stop="editCategory(cat)"></div>
                  <div class="actionItem delete"
                    v-on:click.stop="deleteCategory(cat, selected2, i)"></div>
                </div>
                <div class="catName">{{cat.name[lang]}}</div>
              </li>
            </div>
            <button class="addCategory" v-on:click="addCategory3">
              <img src="../assets/plus-circle.png">
              Add new category
            </button>
          </div>
        </div>
        <div class="modalAction">
          <div class="langSelectorBtn"
            v-on:click.stop="langSelectorOpen = !langSelectorOpen">
            <b>{{lang}}</b>
            <div class="langSelector" v-if="langSelectorOpen"
              v-on:click.stop="doNothing">
              <li v-on:click="selectLang('en')">EN - English</li>
              <li v-on:click="selectLang('id')">ID - Bahasa Indonesia</li>
            </div>
          </div>
          <div class="selectedCategories" v-if="allSelected.length > 0">
            Selected category:
            <b>
              {{allSelected[0].name[lang]}}
              <span v-if="allSelected.length > 1">
                + {{allSelected.length - 1}} more
              </span>
            </b>
            <span class="clear" v-on:click="clearSelection">Clear</span>
          </div>
          <div class="divider"></div>
          <button class="btn btnSecondary" v-on:click="close(false)"
            v-if="!btnDisabled">Cancel</button>
          <button :class="{btn: 1, btnPrimary: 1, disabled: btnDisabled}"
            v-on:click="close(true)">
            <span v-if="btnDisabled">Moving content...</span>
            <span v-else>Select Category</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <MediaInputer ref="formInputer"/>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import MediaInputer from '@/components/MediaInputer.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'confirmation',
  components: {
    MediaInputer,
    Confirmation,
    Snackbar,
  },
  data() {
    return {
      show: false,
      next: null,
      directory: null,
      btnDisabled: false,
      categories: [],
      selected: null,
      selected2: null,
      selected3: null,
      allSelected: [],

      /**
       * Loading
       *
       */
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,

      /**
       * Language
       *
       */
      langSelectorOpen: false,
      lang: 'id',
    };
  },
  methods: {
    modalClicked() { this.langSelectorOpen = false; },
    doNothing() {},
    clearSelection() {
      this.$refs.confirmDialog.open({
        title: 'Clear Selection',
        desc: 'Are you sure you want to clear category selection for this content?',
        action: 'Clear Selection',
      }, (b) => {
        if (!b) return;
        this.allSelected = [];
        // eslint-disable-next-line
        for (const c of this.categories) {
          c.selected = false;
          // eslint-disable-next-line
          for (const cs of c.subcategories) {
            cs.selected = false;
            // eslint-disable-next-line
            for (const cs2 of cs.subcategories) {
              cs2.selected = false;
            }
          }
        }
      });
    },
    open(d, next) {
      this.directory = d.directory;
      this.show = true;
      this.next = next;

      /**
       * Reset UI
       *
       */
      this.loading = false;
      this.loading1 = false;
      this.loading3 = false;
      this.selected = null;
      this.selected3 = null;
      if (d.categories && d.categories.length > 0) {
        this.allSelected = JSON.parse(JSON.stringify(d.categories));
      } else {
        this.allSelected = [];
      }

      this.getCategories();
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') {
        this.next(b, this.allSelected);
      }
    },

    selectLang(lang) {
      this.lang = lang;
      this.langSelectorOpen = false;
    },

    /**
     * Category
     *
     */
    toggleSelect(item, parent, parent2) {
      // eslint-disable-next-line
      item.selected = !item.selected;
      if (item.selected) {
        this.allSelected.push(item);
        if (parent && !parent.selected) {
          // eslint-disable-next-line
          parent.selected = true;
          this.allSelected.push(parent);
        }
        if (parent2 && !parent2.selected) {
          // eslint-disable-next-line
          parent2.selected = true;
          this.allSelected.push(parent2);
        }
      } else {
        let i = 0;
        // eslint-disable-next-line
        for (const cat of this.allSelected) {
          if (cat.id === item.id) {
            this.allSelected.splice(i, 1);
          }
          i += 1;
        }
      }
    },
    deleteCategory(item, parent, i) {
      this.$refs.confirmDialog.open({
        title: 'Delete Category',
        desc: `Are you sure you want to delete ${item.name} from category list?`,
        action: 'Delete',
      }, (b) => {
        if (!b) return;
        if (parent) parent.subcategories.splice(i, 1);
        else this.categories.splice(i, 1);
        this.$http.get(this.$config.uri(`category/${item.id}/delete`)).then((r) => {});
      });
    },
    editCategory(item) {
      this.$refs.formInputer.open({
        title: 'Edit Category',
        placeholder: 'Category name...',
        model: item.name,
        action: 'Save',
        multiLang: true,
      }, (b, val) => {
        if (!b || !val) return;
        // eslint-disable-next-line
        item.name = val;
        this.$http.post(this.$config.uri('category/save'), {
          id: item.id,
          name: val,
        }).then((r) => {
          this.$refs.snackbar.open({ content: 'Changes has been saved' });
        });
      });
    },
    addCategory() {
      this.$refs.formInputer.open({
        title: 'Add Category',
        placeholder: 'Category name...',
        action: 'Save',
        model: { id: '', en: '' },
        multiLang: true,
      }, (b, val) => {
        if (!b || !val) return;
        this.loading1 = true;
        this.$http.post(this.$config.uri('category/save'), {
          directoryId: this.directory.id,
          name: val,
        }).then((r) => {
          this.categories.push(r.data.data);
          this.loading1 = false;
        });
      });
    },
    addCategory2() {
      this.$refs.formInputer.open({
        title: 'Add Sub Category',
        placeholder: 'Category name...',
        action: 'Save',
        model: { id: '', en: '' },
        multiLang: true,
      }, (b, val) => {
        if (!b || !val) return;
        this.loading2 = true;
        this.$http.post(this.$config.uri('category/save'), {
          directoryId: this.directory.id,
          parentId: this.selected.id,
          name: val,
        }).then((r) => {
          if (!this.selected.subcategories) this.selected.subcategories = [];
          this.selected.subcategories.push(r.data.data);
          this.loading2 = false;
        });
      });
    },
    addCategory3() {
      this.$refs.formInputer.open({
        title: 'Add Sub Category',
        placeholder: 'Category name...',
        action: 'Save',
        model: { id: '', en: '' },
        multiLang: true,
      }, (b, val) => {
        if (!b || !val) return;
        this.loading3 = true;
        this.$http.post(this.$config.uri('category/save'), {
          directoryId: this.directory.id,
          parentId: this.selected2.id,
          name: val,
        }).then((r) => {
          if (!this.selected2.subcategories) this.selected2.subcategories = [];
          this.selected2.subcategories.push(r.data.data);
          this.loading3 = false;
        });
      });
    },
    getCategories() {
      this.loading = true;
      const parentId = (this.selected) ? this.selected.id : '';
      const uri = `category/all?_pid=${parentId}&_did=${this.directory.id}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.categories = (r.data.status === 200) ? r.data.data : [];
        // eslint-disable-next-line
        for (const sc of this.allSelected) {
          // eslint-disable-next-line
          for (const c of this.categories) {
            if (c.id === sc.id) c.selected = true;
            // eslint-disable-next-line
            for (const cs of c.subcategories) {
              if (cs.id === sc.id) cs.selected = true;
              // eslint-disable-next-line
              for (const cs2 of cs.subcategories) {
                if (cs2.id === sc.id) cs2.selected = true;
              }
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 20px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 740px;
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: -30px -20px 0;
        padding: 14px 20px 10px;
        border-bottom: #ccc 1px solid;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .loadingCategory{
        position: absolute;
        top: 55px; bottom: 62px; left: 0; right: 0;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40px auto;
        background-color: #f5f5f5;
        z-index: 9;
        &.loading2{
          top: 0; bottom: 0;
        }
      }
      .categoryCnt{
        display: flex;
        background-color: #f5f5f5;
        margin: 0 -20px 0;
        padding: 0;
        min-height: 280px;
        .categoryItem{
          width: 33.3333%;
          box-sizing: border-box;
          padding: 10px 0;
          max-height: 400px;
          overflow-y: auto;
          position: relative;
          &.catItemLeft{
            border-right: #ccc 1px solid;
          }
          &.catItemMid{
            border-right: #ccc 1px solid;
          }
          li{
            list-style: none;
            cursor: pointer;
            padding: 6px 0;
            padding-right: 30px;
            position: relative;
            transition: all .3s ease;
            display: flex;
            align-items: center;
            .checkbox{
              width: 14px; height: 14px;
              border-radius: 3px;
              border: #999 2px solid;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all .2s ease;
              margin-right: 10px;
              margin-left: 20px;
              &.checked{
                border-color: #0067ff !important;
                background-color: #0067ff !important;
                background-image: url(../assets/checked.png);
                background-size: 14px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            .catName{
              width: calc(100% - 44px);
              box-sizing: border-box;
              padding-right: 48px;
            }
            .action{
              position: absolute;
              display: flex;
              right: 26px; top: 0; bottom: 0;
              align-items: center;
              opacity: 0;
              .actionItem{
                width: 24px; height: 24px;
                border-radius: 50%;
                background-size: 12px auto;
                background-position: center;
                background-repeat: no-repeat;
                transition: all .3s ease;
                &:hover{
                  background-color: #ccc;
                }
                &.edit{
                  background-image: url(../assets/edit-black.png);
                }
                &.delete{
                  background-size: 16px auto;
                  background-image: url(../assets/trash-bin.png);
                }
              }
            }
            &:hover{
              background-color: #ddd;
              .action{
                opacity: 1;
              }
              .checkbox{
                border-color: #222;
              }
            }
            &.selected{
              background-color: #c8deff;
            }
            &.canMore{
              &:before{
                content: "";
                position: absolute;
                right: 10px; top: 0; bottom: 0;
                width: 12px;
                background-image: url(../assets/right-arrow.png);
                background-size: 12px auto;
                background-position: center;
                background-repeat: no-repeat;
                opacity: .5;
              }
            }
          }
          .addCategory{
            float: left;
            border: none;
            border-radius: 50px;
            color: #0747a6;
            font-size: 14px;
            // background-color: #fff;
            padding: 6px 14px 5px 10px;
            margin: 4px 0 -4px;
            transition: all .3s ease;
            margin-left: 9px;
            cursor: pointer;
            background: none;
            &:hover{
              background-color: #ddd;
            }
            img{
              height: 18px;
              float: left;
              margin: -2px 10px -4px 1px;
            }
          }
        }
      }
      p{
        margin: 0;
        color: #767676;
      }
      .checkCnt{
        margin: 20px 0 6px;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        p{
          color: red;
        }
        .checkboxOuter{
          position: absolute;
          left: -8px; top: -6px;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            background-color: #eee;
          }
          .checkbox{
            width: 14px; height: 14px;
            border-radius: 3px;
            border: #999 2px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all .2s ease;
            &.checked{
              border-color: red !important;
              background-color: red !important;
              background-image: url(../assets/checked.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              .checkInner{
              }
            }
          }
        }
        &:hover{
          .checkboxOuter{
            .checkbox{
              border-color: #444;
            }
          }
        }
      }
      .modalAction{
        margin: 0 -20px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #ccc 1px solid;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .selectedCategories{
          margin-left: 10px;
          font-size: 15px;
          max-width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .clear{
            color: #0057d8;
            cursor: pointer;
            margin-left: 10px;
            display: inline-block;
          }
        }
        .divider{
          margin-left: auto;
        }
        .btn{
          margin-left: 10px;
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
    }
  }
</style>
